module.exports = __webpack_public_path__ + "media/application/images/process_steps/mobile_bookstack_01-a32fe589dbfaa3bfb4cbf39922989f81.png";